import React from "react";
import Home from "./pages/Home";
import LoginScreen from "./pages/Login/LoginScreen";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import ScrollIntoView from "./components/Scrollintoview";
// import RegisterScreen from "./components/RegisterScreen";
import NotFoundPage from "./components/Notfoundpage";
import Products from "./pages/products/products";
import CustomizeStorePage from "./pages/CustomizeStorePage";
import EditStorePage from "./pages/EditStorePage";
import StoresPage from "./pages/StoresPage";
import { Toaster } from "react-hot-toast";
import StoreScreen from "./pages/StoreScreen";
import DashboardPage from "./pages/DashboardPage";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardUsersPage from "./pages/DashboardUsersPage";
import DashboardProductsPage from "./pages/DashboardProductsPage";
import DashboardStoresPage from "./pages/DashboardStoresPage";
import CartFab from "./components/CartFab";
import CartModal from "./components/modals/CartModal";
import PlaceOrderModal from "./components/modals/PlaceOrderModal";
import DashboardOrdersPage from "./pages/DashboardOrdersPage";
import OrdersPage from "./pages/Orders/Orders";

const App = () => {
  return (
    <div className="main">
      <ChakraProvider>
        <Router>
          <ScrollIntoView>
            <Toaster />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/login" exact component={LoginScreen} />
              {/* <Route path="/register" exact component={RegisterScreen} /> */}
              <ProtectedRoute path="/admin/productlist" component={Products} />
              <ProtectedRoute path="/admin/new-store" component={CustomizeStorePage} />
              <ProtectedRoute path="/admin/edit-store/:slug" component={EditStorePage} />
              <ProtectedRoute path="/admin/stores" component={StoresPage} />
              <ProtectedRoute path="/admin/orders" component={OrdersPage} />
              <ProtectedRoute path="/admin/dashboard/users" component={DashboardUsersPage} />
              <ProtectedRoute path="/admin/dashboard/products" component={DashboardProductsPage} />
              <ProtectedRoute path="/admin/dashboard/orders" component={DashboardOrdersPage} />
              <ProtectedRoute path="/admin/dashboard/stores" component={DashboardStoresPage} />
              <ProtectedRoute path="/admin/dashboard" component={DashboardPage} />
              <Route path="/404" component={NotFoundPage} />
              <Route path="/:slug" component={StoreScreen} />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
            <CartFab />
            <CartModal />
            <PlaceOrderModal />
          </ScrollIntoView>
        </Router>
      </ChakraProvider>
    </div>
  );
};
export default App;
